import accordion from "./accordion"

export default function PointsSummaryPlayoff(){

  var moment = require('moment'); // require
  const timeStamp = Date.now()

  function pointsStandings(url,title,className){
    const pointsStandingsContainer = $(`#points-standings-playoffs-${title}`)

	if( ! pointsStandingsContainer.length ) {
		return;
	}

  // $('#playoffClass').html(className)

    let content = ''

    $.ajax( {
      url: url,
      method: 'GET',
      dataType: 'json',
      error: () => {
        console.log("%cError fetching results!", "color: red; font-weight:700; font-size:20px;",);
      },
      success: data => {
        const timeDate = new Date(timeStamp)
        const dateZone = timeDate.toLocaleTimeString('en-us',{timeZoneName:'short'}).split(' ')[2]
        const dateDate = moment().format('l')
        const dateTime = moment().format('LT')

        $('.updated-on-date').html(`Updated as of ${dateDate} at ${dateTime} ${dateZone}`)

        let counterBottom = 1
          content += `<div class="race race-${title}">`
          // content += `<h3 class="race-name">${title}</h3>`

          // Bottom
          content += `<div class="race-bottom">`
          content += `<div class="race-accordion">`
          content += `<div class="accordion">`
            for ( let result of data ) {
              const position = result.Position <= 9 ? `0${result.Position}` : result.Position
              const fullName = `${result.FullName}`
              const slug = fullName.replace(/\s+/g, '-').toLowerCase();
              const sxPoints = result.PointsSX ? result.PointsSX : 0
              const mxPoints = result.PointsMX ? result.PointsMX : 0
              const totalPoints = result.TotalPoints

              content += `<div class="item">`
              content += `  <div class="title">`
              content += `    <p class="position">${position}</p>`
              content += `    <p class="name">${fullName}</p>`
              content += `    <p class="points points-total">${totalPoints} pts</p>`
              // content += `    <div class="icon"><i class="fas fa-chevron-right"></i></div>`
              content += `  </div>`
              // content += `  <div class="content">`
              // content += `  <div class="wrapper">`
              // content += `    <p class="points points-sx">${sxPoints} pts</p>`
              // content += `    <p class="points points-mx">${mxPoints} pts</p>`
              // content += `  </div>`
              // content += `  </div>`
              content += `</div>`
              counterBottom++
            }
          content += `</div>`
          content += `</div>`
          content += `</div>`

          content += `</div>`

          pointsStandingsContainer.html(content)

          accordion()


      }
    });
  }

  pointsStandings('https://data-aws.amaproracing.com/api/pointstandings/series/thin/2024/X1', '450', 'SMX')
  pointsStandings('https://data-aws.amaproracing.com/api/pointstandings/series/thin/2024/X2', '250', 'SMX')
  // pointsStandings('https://data-aws.amaproracing.com/api/pointstandings/series/thin/2023/M1', '450', 'MX')
  // pointsStandings('https://data-aws.amaproracing.com/api/pointstandings/series/thin/2023/M2', '250', 'MX')

}
